// Import global styles and required components
import "./css/App.css";
import ScrollToTop from "./frontend/components/ScrollToTop";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./frontend/pages/HomePage";
import Navbar from "./frontend/designSystem/Navbar";
import Footer from "./frontend/designSystem/Footer.jsx";
import ContactUsPage from "./frontend/pages/ContactUsPage.js";
import AboutUsPage from "./frontend/pages/AboutUsPage.js";
import InvestmentsPage from "./frontend/pages/InvestmentsPage.js";
import PensionsPage from "./frontend/pages/PensionsPage.js";
import ProtectionPage from "./frontend/pages/ProtectionPage.js";
import EquityReleasePage from "./frontend/pages/EquityRelease.js";
import BlogsPage from "./frontend/pages/BlogsPage.js";
import CharityPage from "./frontend/pages/CharityPage.js";
import FAQsPage from "./frontend/pages/FAQPage.js";
import CalculatorPage from "./frontend/pages/CalculatorPage.js";
import BlogPostPage from "./frontend/pages/BlogPostPage.js";
import RelevantLifeTaxPage from "./frontend/pages/calculators/RelevantLifeTaxPage.js";
import PensionShortfallPage from "./frontend/pages/calculators/PensionShortfallPage.js";
import InheritanceTaxPage from "./frontend/pages/calculators/InheritanceTaxPage.js";
import InvestmentCalculatorPage from "./frontend/pages/calculators/InvestmentPage.js";
import PrivacyPolicyPage from "./frontend/pages/PrivacyPolicy.js";
import { HelmetProvider } from "react-helmet-async";
// Main App component sets up routing and layout
function App() {
  return (
      // Router provides client-side routing for the app
    <HelmetProvider>
      <Router>
        {/* ScrollToTop ensures the page scrolls to top or anchor on route change */}
        <ScrollToTop />
        <div className="App">
          <Navbar />
          {/* Navbar can be added here if needed */}
          {/* Define application routes */}
          <Routes>
            {/* Home page route */}
            <Route path="/" element={<HomePage />} />
            <Route path="/contact-us" element={<ContactUsPage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route path="/investments" element={<InvestmentsPage />} />
            <Route path="/pensions" element={<PensionsPage />} />
            <Route path="/protection" element={<ProtectionPage />} />
            <Route path="/equity-release" element={<EquityReleasePage />} />
            <Route path="/blog" element={<BlogsPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/charity" element={<CharityPage />} />
            <Route path="/faq" element={<FAQsPage />} />
            <Route path="/calculators" element={<CalculatorPage />} />
            <Route
              path="/relevant-life-tax"
              element={<RelevantLifeTaxPage />}
            />
            <Route
              path="/pension-shortfall"
              element={<PensionShortfallPage />}
            />
            <Route path="/inheritance-tax" element={<InheritanceTaxPage />} />
            <Route
              path="/investment-calculator"
              element={<InvestmentCalculatorPage />}
            />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          </Routes>
          {/* <ContactUsPage /> */}
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}
  
// Export the App component as the root of the application
export default App;
